import {
	AssociationContact,
	BankAccount,
	Checklist,
	Choice,
	Contact,
	Currency,
	DateRange,
	Ledger,
	Number,
	Portfolio,
	PortfolioGroup,
	PostingSetting,
	Property,
	PropertyGroup,
	PropertyManager,
	SelectFilter,
	StatementSetting,
	Tag,
	Unit,
	User,
	UserStatic,
	VendorContact,
	VendorTrade,
	VendorType
} from './index';

export default {
	bankAccount: BankAccount,
	contact: Contact,
	user: User,
	userStatic: UserStatic,
	unit: Unit,
	number: Number,
	dateRange: DateRange,
	choice: Choice,
	checklist: Checklist,
	portfolio: Portfolio,
	portfolioGroup: PortfolioGroup,
	property: Property,
	propertyGroup: PropertyGroup,
	propertyManager: PropertyManager,
	associationContact: AssociationContact,
	vendorTrade: VendorTrade,
	currency: Currency,
	postingSetting: PostingSetting,
	tag: Tag,
	select: SelectFilter,
	statementSetting: StatementSetting,
	vendorContact: VendorContact,
	ledger: Ledger,
	vendorType: VendorType
};
